module.exports = __webpack_public_path__ + "static/media/login-page-banner2.7eeb20a5.png";